var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'core', 'view/ledger-report', 'app-common/view/base', 'template/report/landing.htm', 'template/report/zero-states/balance-sheet.htm'], function($, core, LedgerReportView, BaseView, landingViewTemplate, zeroStateTemplate) {
  var BalanceSheetReportPage;
  return BalanceSheetReportPage = (function(_super) {

    __extends(BalanceSheetReportPage, _super);

    function BalanceSheetReportPage() {
      BalanceSheetReportPage.__super__.constructor.apply(this, arguments);
    }

    BalanceSheetReportPage.prototype.pageId = 'balance-sheet';

    BalanceSheetReportPage.prototype.reportType = 'balance-sheet';

    BalanceSheetReportPage.prototype.initialize = function(options, params) {
      var _this = this;
      this.loadingPromise = this.refreshMetadata();
      return this.loadingPromise.always(function(data) {
        var features, hasStatement;
        _this.settingsModel = core.getModel('clientsettings');
        features = _this.settingsModel.get('features') || [];
        if (!core.isCurrentClientBookkeeper() && (!_this.hasClosedReportsIn(data) && features.zeroStatesReports)) {
          hasStatement = core.getEarliestStatementTime() !== null;
          return BaseView.prototype.render.call(_this, _.template(zeroStateTemplate, {
            core: core,
            hasStatement: hasStatement
          }));
        } else {
          options = _.extend(options, {
            title: 'Balance Sheet',
            icon: 'ss-files ss-gizmo',
            features: ['date-range', 'edit', 'search', 'overview'],
            ledgerCategories: [
              {
                id: 'assets',
                title: 'Assets',
                mainappId: '1'
              }, {
                id: 'liabilities',
                title: 'Liabilities',
                mainappId: '3'
              }, {
                id: 'equity',
                title: 'Equity',
                mainappId: '5'
              }
            ],
            template: landingViewTemplate,
            url: function(clientId, from, to, page, ledgerId) {
              return "view/json/" + clientId + "/" + ledgerId + "/" + from + "/" + to + "?page=" + page + "&results-per-page=50";
            },
            ledgersUrl: function(clientId, from, to) {
              return "balance-sheet/json/" + clientId + "/" + to;
            }
          });
          return BalanceSheetReportPage.__super__.initialize.call(_this, options, params);
        }
      });
    };

    return BalanceSheetReportPage;

  })(LedgerReportView);
});
